module.exports = "/images/milano-14.jpg";